import { t } from "i18next";

export const roleOptions: any = [
    {
        value: 'padeltech_administrator',
        label: 'Administrador'
    },
    {
        value: 'padeltech_manager',
        label: 'Manager'
    },
    {
        value: 'padeltech_coach',
        label: 'Coach'
    },
    {
        value: 'padeltech_athlete',
        label: 'Athlete'
    }
];
